import { render, staticRenderFns } from "./SearchBoxProfissao.vue?vue&type=template&id=535cbb1f&scoped=true"
import script from "./SearchBoxProfissao.vue?vue&type=script&lang=js"
export * from "./SearchBoxProfissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535cbb1f",
  null
  
)

export default component.exports